import { HttpClient, HttpParams } from '@angular/common/http';
import { CacheService } from '../cache';
import { ResourceService } from './resource';
import { Booking } from '../../models/booking';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BookingService extends ResourceService<Booking> {
  /**
   * @constructor
   * Creates an instance of the BookingService
   *
   * @param {HttpClient} http Injected instance of HttpClient
   * @param {CacheService} cache Injected instance of CacheService
 */
  constructor(
    protected http: HttpClient,
    protected cache: CacheService
  ) {
    super(http, cache, 'bookings');
  }

  /**
   * Sends a PUT request to the /bookings/:id/cancel endpoint
   * @remarks
   * to cancel a booking
   * 
   * @param {string} id Id of booking to be cancelled
   * @returns {Observable} Returns an observable of any, with a server-side representations of the matching resources
   */
  cancelBooking(id: string) {
    return this.http.put<any>(`${this.endpoint}/${id}/cancel`, {})
      .pipe(map((resp: any) => {
        this.cache.remove(`${this.endpoint}/${id}`);
        this.cache.remove(`${this.endpoint}`);
        return resp;
      }))
  }



  /**
  * Sends a GET request to the /bookings/export/ endpoint
  * @remarks
  * to export bookigns
  * 
  * 
  * @returns {Observable} Returns an observable of any, with a server-side representations of the matching resources
  */

  exportBookings(params?: any) {
    return this.http.get<any>(`${this.endpoint}/export`, { params })
      .pipe(map((resp: any) => {
        this.cache.remove(`${this.endpoint}`);
        this.cache.remove(`${this.endpoint}`);
        return resp;
      }))
  }

  /**
  * Sends a PUT request to the /bookings/:id/confirm endpoint
  * @remarks
  * to confirm a booking request on the admin app
  * 
  * @param {string} id Id of booking to be confirmed
  * 
  * @returns {Observable} Returns an observable of any, with a server-side representations of the matching resources
  */

  confirmBooking(id: string, data: { confirmed: boolean }) {
    return this.http.put<any>(`${this.endpoint}/${id}/confirm`, data)
      .pipe(map((resp: any) => {
        this.cache.remove(`${this.endpoint}/${id}`);
        this.cache.remove(`${this.endpoint}`);
        return resp;
      }))
  }

  /**
  * Sends a GET request to the /bookings endpoint
  * @remarks
  * to get the count of a booking
  * 
  * @param {any} params pass desired params to get what you want
  * 
  * @returns {Observable} Returns an observable of any, with a server-side representations of the matching resources
  */

  getBookingCount(params: any) {
    return this.http.get<any>(`${this.endpoint}`, { params })
      .pipe(map((resp: any) => {
        this.cache.remove(`${this.endpoint}`);
        this.cache.remove(`${this.endpoint}`);
        return resp;
      }))
  }

  /**
  * Sends a PUT request to the /bookings/:id/reject endpoint
  * @remarks
  * to reject a booking request on the admin app
  * 
  * @param {string} id Id of booking to be rejected
  * 
  * @returns {Observable} Returns an observable of any, with a server-side representations of the matching resources
  */
  rejectBooking(id: string, data: { rejected: boolean }) {
    return this.http.put<any>(`${this.endpoint}/${id}/reject`, data)
      .pipe(map((resp: any) => {
        this.cache.remove(`${this.endpoint}/${id}`);
        this.cache.remove(`${this.endpoint}`);
        return resp;
      }))
  }

  /**
  * Sends a GET request to the /bookings/priceline/:id/ endpoint
  * @remarks
  * to get priceline informatuion on a booking
  * 
  * @param {string} id Id of booking to be cancelled
  * @returns {Observable} Returns an observable of any, with a server-side representations of the matching resources
  */
  getPriceLineInfoOnABooking(id: string) {
    return this.http.get<any>(`${this.endpoint}/priceline/${id}`)
      .pipe(map((resp: any) => {
        this.cache.remove(`${this.endpoint}/${id}`);
        this.cache.remove(`${this.endpoint}`);
        return resp;
      }))
  }



  /**
 * Sends a POST request to the /bookings/retrieve endpoint
 * @remarks
 * to retrieve detail of a flight
 * 
 * @returns {Observable} Returns an observable of any, with a server-side representations of the matching resources
 */
  retrieveFlightDetails(payload: any) {
    return this.http.post<any>(`${this.endpoint}/syncandretrieve`, payload)
      .pipe(map((resp: any) => {
        this.cache.remove(`${this.endpoint}/syncandretrieve`);
        this.cache.remove(`${this.endpoint}/syncandretrieve`);
        return resp;
      }))
  }


  /**
 * Sends a POST request to the /bookings/quotepart endpoint
 * @remarks
 * to quote booking part of a flight
 * 
 * @returns {Observable} Returns an observable of any, with a server-side representations of the matching resources
 */
  quoteBookingPart(payload: any) {
    return this.http.post<any>(`${this.endpoint}/quotepart`, payload)
      .pipe(map((resp: any) => {
        this.cache.remove(`${this.endpoint}/quotepart`);
        this.cache.remove(`${this.endpoint}/quotepart`);
        return resp;
      }))
  }

  /**
 * Sends a POST request to the /bookings/payandissueticket endpoint
 * @remarks
 * to pay and issue ticket for a  booking part of a flight
 * 
 * @returns {Observable} Returns an observable of any, with a server-side representations of the matching resources
 */
  payAndIssueTicket(payload: any) {
    return this.http.post<any>(`${this.endpoint}/payandissueticket`, payload)
      .pipe(map((resp: any) => {
        this.cache.remove(`${this.endpoint}/payandissueticket`);
        this.cache.remove(`${this.endpoint}/payandissueticket`);
        return resp;
      }))
  }



  /**
  * Sends a PUT request to the /bookings/:id/modify endpoint
  * @remarks
  * to modify user booking
  * 
  * @param {string} id Id of booking to be cancelled
  * @returns {Observable} Returns an observable of any, with a server-side representations of the matching resources
  */
  modifyUserBooking(id: string, data: any) {
    return this.http.put<any>(`${this.endpoint}/${id}/modify`, data)
      .pipe(map((resp: any) => {
        this.cache.remove(`${this.endpoint}/${id}`);
        this.cache.remove(`${this.endpoint}`);
        return resp;
      }))
  }

  /**
  * Sends a PUT request to the /bookings/:id/cancel endpoint
  * @remarks
  * to cancel user booking
  * 
  * @param {string} id Id of booking to be cancelled
  * @returns {Observable} Returns an observable of any, with a server-side representations of the matching resources
  */
  cancelUserBooking(id: string, data: any) {
    return this.http.put<any>(`${this.endpoint}/${id}/cancel`, data)
      .pipe(map((resp: any) => {
        this.cache.remove(`${this.endpoint}/${id}`);
        this.cache.remove(`${this.endpoint}`);
        return resp;
      }))
  }

  /**
  * Sends a PUT request to the /bookings/:id/priceline/cancel endpoint
  * @remarks
  * to cancel admin booking
  * 
  * @param {string} id Id of booking to be cancelled
  * @returns {Observable} Returns an observable of any, with a server-side representations of the matching resources
  */
  cancelAdminBooking(id: string, data: any) {
    return this.http.put<any>(`${this.endpoint}/${id}/priceline/cancel`, data)
      .pipe(map((resp: any) => {
        this.cache.remove(`${this.endpoint}/${id}`);
        this.cache.remove(`${this.endpoint}`);
        return resp;
      }))
  }
  /**
  * Sends a GET request to the /bookings/analytics endpoint
  * @remarks
  * to get booking Analytics
  * 
  * @returns {Observable} Returns an observable of any, with a server-side representations of the matching resources
  */
  getBookingAnalytics() {
    return this.http.get<any>(`${this.endpoint}/analytics`)
      .pipe(map((resp: any) => {
        this.cache.remove(`${this.endpoint}`);
        this.cache.remove(`${this.endpoint}`);
        return resp;
      }))
  }

  /**
  * Sends a POST request to the /bookings/analytics endpoint
  * @remarks
  * to resend booking confirmation
  *  @param {string} id Id of booking to be cancelled

  * @returns {Observable} Returns an observable of any, with a server-side representations of the matching resources
  */
  resendBookingConfirmation(id: any, { }) {
    return this.http.post<any>(`${this.endpoint}/${id}/resend-confirmation`, {})
      .pipe(map((resp: any) => {
        this.cache.remove(`${this.endpoint}`);
        this.cache.remove(`${this.endpoint}`);
        return resp;
      }))
  }

  /**
  * Sends a POST request to the /bookings/manual endpoint
  * @remarks
  * to create manual bookings

  * @returns {Observable} Returns an observable of any, with a server-side representations of the matching resources
  */
  createManualBooking(payload: any) {
    return this.http.post<any>(`${this.endpoint}/manual`, payload)
      .pipe(map((resp: any) => {
        this.cache.remove(`${this.endpoint}`);
        this.cache.remove(`${this.endpoint}`);
        return resp;
      }))
  }

  /**
  * Sends a PUT request to the /bookings/manual/:id endpoint
  * @remarks
  * to update manual bookings

  * @returns {Observable} Returns an observable of any, with a server-side representations of the matching resources
  */
  updateManualBooking(id: any, payload: any) {
    return this.http.put<any>(`${this.endpoint}/manual/${id}`, payload)
      .pipe(map((resp: any) => {
        this.cache.remove(`${this.endpoint}`);
        this.cache.remove(`${this.endpoint}`);
        return resp;
      }))
  }

  /**
   * Sends a POST request to the /bookings/manual/:id/upload-pdf endpoint
   * @remarks
   * to update existing manual booking with pdf
   * 
   * @returns {Observable} Returns an observable of any, with a server-side representations of the matching resources
   */
  updateManualBookingWithPDF(id: any, payload: any) {
    const body = new FormData();
    body.append('file', payload.file);

    return this.http.post<any>(`${this.endpoint}/manual/${id}/pdf`, body)
      .pipe(map((resp: any) => {
        this.cache.remove(`${this.endpoint}`);
        return resp;
      }))
  }

  /**
   * Sends a POST request to the /bookings/manual/upload-pdf endpoint
   * @remarks
   * to upload manual booking pdf
   * 
   * @returns {Observable} Returns an observable of any, with a server-side representations of the matching resources
   */
  uploadManualBookingPDF(payload: any) {
    return this.http.post<any>(`${this.endpoint}/manual/upload-pdf`, payload)
      .pipe(map((resp: any) => {
        this.cache.remove(`${this.endpoint}`);
        return resp;
      }))
  }

  /**
* Sends a POST request to the /payment-reminder endpoint
* @remarks
* to send payment-reminder 
* 
* @returns {Observable} Returns an observable of any, with a server-side representations of the matching resources
*/
  paymentReminder(id: any) {
    return this.http.post<any>(`${this.endpoint}/${id}/payment-reminder`, {})
      .pipe(map((resp: any) => {
        this.cache.remove(`${this.endpoint}`);
        this.cache.remove(`${this.endpoint}`);
        return resp;
      }))
  }

  /**
* Sends a POST request to the /contact-support endpoint
* @remarks
* to cancel booking 
* 
* @returns {Observable} Returns an observable of any, with a server-side representations of the matching resources
*/
  contactSupport(payload: any) {
    return this.http.post<any>(`contact-support`, payload)
      .pipe(map((resp: any) => {
        this.cache.remove(`contact-support`);
        this.cache.remove(`contact-support`);
        return resp;
      }))
  }

  /**
* Sends a POST request to the /contact-support endpoint
* @remarks
* to cancel booking 
* 
* @returns {Observable} Returns an observable of any, with a server-side representations of the matching resources
*/
  makeAdminPayment(payload: any, type: string, id: any) {
    return this.http.post<any>(`${this.endpoint}/book-admin/${type}?id=${id}`, payload)
      .pipe(map((resp: any) => {
        this.cache.remove(`${this.endpoint}`);
        this.cache.remove(`${this.endpoint}`);
        return resp;
      }))
  }

  /**
  * Sends a GET request to the /bookings/combined endpoint
  * @remarks
  * to get combined bookings
  * 
  * @param {string | any} params Business ID string or query params object (e.g. { business: businessId })
  * @returns {Observable} Returns an observable of any, with server-side representations of matching resources
  */
  getCombinedBookings(params?: string | any) {
    const queryParams = typeof params === 'string' ? { business: params } : params;
    return this.http.get<any>(`${this.endpoint}/combined`, { params: queryParams })
      .pipe(map((resp: any) => {
        this.cache.remove(`${this.endpoint}`);
        this.cache.remove(`${this.endpoint}`);
        return resp;
      }));
  }

}

